<div class="alert alert-primary alert-dismissible fade show py-2 mb-0 fz-16 text-center w-100 bs-2 h45"
    id="announcement" role="alert" *ngIf="switchEnabled">
    <i class="fas fa-bullhorn mr-2"></i> we invite you to join us in experiencing New User Interface, Let's
    experience
    it. <a href="javascript:void(0)" (click)="fnSwitch()" class="text-decoration-underline">Switch to New UI
        Now!</a>
    <button type="button" class="btn py-0 ml-2" data-dismiss="alert" (click)="toggle()">
        <i class="fas fa-times"></i>
    </button>
</div>

<app-header *ngIf="!signInVisible" class="layout-header" [showSideBar]="showSideBar" [menuToggleEnabled]="true"
    (menuToggle)="fnToggale()" [title]="title" [isAuthorized]="true">
</app-header>

<!-- <dx-drawer class="layout-body" position="before" [hideOnOutsideClick]="shaderEnabled" [minSize]="showSideBar ? 60 : 0" [openedStateMode]="menuMode" [revealMode]="menuRevealMode" [minSize]="minMenuSize" [shading]="shaderEnabled" [(opened)]="menuOpened"> -->
<section *ngIf="!signInVisible">
    <div id="mainContainer" class="wrapper">

        <app-side-navigation-menu [ngClass]="{'d-none':!showSideBar,'d-flex':showSideBar}" [items]="menuItems"
            [compactMode]="!menuOpened" [selectedItem]="selectedRoute" (selectedItemChanged)="navigationChanged($event)"
            (openMenu)="navigationClick()">
        </app-side-navigation-menu>

        <dx-scroll-view class="full-height-scrollable">
            <div class="content"
                [ngClass]="{'right-content':showSideBar,'bill-content':redirectToBillAuth,'public-content':redirectToPublicContentAuth}">
                <ng-content></ng-content>
            </div>

            <div class="content-block-footer zi-2030">
                <app-footer class="text-right h100 bg-white Border-primary bg-left-none" *ngIf="isWhiteLabled == 'No'">
                    <!-- Copyright © {{year}} EasyBillnPay Techno Services Private Limited. -->

                    <div class="ess-fs-14 h-100 d-flex align-items-end justify-content-end px-2">
                         <span class="pr-2 fz-12"><i>App version: ({{appVersion}})</i></span>
                        <!-- <img src="assets/img/StaffingGo.png" alt="PoweredBy" width="70px" class="img-responsive"><br> -->
                        <span class="">Powered By</span>
                        <a [href]="footerLink ? footerLink : 'https://www.staffinggo.in/'" target="_blank"
                            class="ess-fs-14 pl-2">
                            <img [src]="footerImg ? footerImg : 'assets/img/PoweredBy.png'" alt="PoweredBy" width="72px"
                                class="img-responsive">
                        </a>
                       

                    </div>

                </app-footer>
            </div>
        </dx-scroll-view>

    </div>
</section>
<section *ngIf="signInVisible">
    <app-sign-in *ngIf="signInVisible"></app-sign-in>
</section>
<!-- </dx-drawer> -->